<template>
  <div>
    <catalog-select
      ref="catalog_select"
      catalog-name="статус объявления"
      :is-disabled="isDisabled"
      :state="state"
      :initial-value="value"
      :get-item-by-id="getJobPosting"
      :get-list="getItems"
      :can-create-catalog="canEditJobPostingStatus()"
      :drop-up="dropUp"
      @onSelect="$emit('onSelect', $event)"
      @open-modal="isModalVisible = true"
    />

    <job-posting-status
      v-if="isModalVisible"
      :create-id="0"
      @modal-closed="isModalVisible = false"
      @refresh="onCatalogItemCreated"
    />
  </div>
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import CatalogSelect from "../CatalogSelect.vue";
    import JobPostingStatus from "./JobPostingStatus.vue";

export default {
  name: "JobPostingStatusSelect",
  components: { JobPostingStatus, CatalogSelect },
  mixins: [
    catalogs,
    permissions,
  ],
  props: {
    isDisabled: { type: Boolean, default: null },
    state: { type: Boolean, default: null },
    dropUp: { type: Boolean, default: false },
    value: { type: Number, default: null },
    excludeIds: { type: Array, default: () => [] }
  },
  data() {
    return {
      isModalVisible: false
    }
  },
  methods: {
    async getItems() {
      const result = await this.getJobPostingStatusesSearch('');
      let items = (result && result.data) ? result.data : [];

      if (this.excludeIds && this.excludeIds.length) {
        items = items.filter(item => !this.excludeIds.includes(item.id));
      }

      return items;
    },
    async getJobPosting(id) {
      const result = await this.getJobPostingStatusById(id);
      return (result && result.data) ? result.data : null;
    },
    async onCatalogItemCreated(newItem) {
      this.$refs.catalog_select.onItemCreated(newItem);
      this.isModalVisible = false;
    },
    // Permissions
    canEditJobPostingStatus() {
      return this.hasPermission([PERM.RECRUIT_JOB_POSTING_EDIT]);
    }
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/JobPostingStatuses/JobPostingStatusSelect.vue